"use strict";

exports.__esModule = true;
exports.isProd = exports.isTest = void 0;

var isTest = function isTest() {
  return process.env.NODE_ENV === "test";
};

exports.isTest = isTest;

var isProd = function isProd() {
  return process.env.NODE_ENV === "prod";
};

exports.isProd = isProd;